import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Navbar from '@/components/common/BaseNavbar.vue';
//import Footer from '@/components/common/BaseFooter.vue'
//import { useAuthStore } from '@/stores/auth'

export default {
  name: 'App',
  components: {
    Navbar
    //   Footer
  },
  setup() {
    const route = useRoute();
    // const authStore = useAuthStore()

    // 全局加载状态
    const globalLoading = computed(() => {
      return true; // 修改
      // return authStore.authLoading || authStore.bindLoading
    });
    return {
      globalLoading,
      route
    };
  }
};